<template>
	<div v-if="getPost">
		<HeadBanner
			v-if="$store.state.selected_menu"
			:itemData="$store.state.selected_menu"
		/>
		<Breadcrumb />
		<intersect @enter="animate = true">
			<div
				class="container article news-media-inner fadeUp"
				:class="animate ? 'animate' : ''"
			>
				<h1 class="noto-semibold ttl">
					{{ getPost.title }}
				</h1>
				<div class="main">
					<div class>
						<div class="video-box" style="display: block">
							<picture>
								<source
									media="(max-width: 767px)"
									:srcset="_.get(getPost, 'images.0.devices.mobile')"
								/>
								<source
									media="(max-width: 1023px)"
									:srcset="_.get(getPost, 'images.0.devices.tablet')"
								/>
								<img
									:src="_.get(getPost, 'images.0.devices.desktop')"
									class="img-absolute"
									alt
								/>
							</picture>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="100.002"
								height="99.999"
								viewBox="0 0 100.002 99.999"
								v-if="_.get(getPost, 'video')"
							>
								<path
									id="Subtraction_136"
									data-name="Subtraction 136"
									d="M-16441,1051a49.691,49.691,0,0,1-19.463-3.929,49.828,49.828,0,0,1-15.895-10.716,49.829,49.829,0,0,1-10.715-15.893A49.662,49.662,0,0,1-16491,1001a49.662,49.662,0,0,1,3.93-19.462,49.829,49.829,0,0,1,10.715-15.893,49.826,49.826,0,0,1,15.895-10.715A49.689,49.689,0,0,1-16441,951a49.689,49.689,0,0,1,19.463,3.929,49.81,49.81,0,0,1,15.893,10.715,49.775,49.775,0,0,1,10.715,15.893A49.662,49.662,0,0,1-16391,1001a49.663,49.663,0,0,1-3.93,19.462,49.777,49.777,0,0,1-10.715,15.893,49.814,49.814,0,0,1-15.893,10.716A49.691,49.691,0,0,1-16441,1051Zm-7.713-66.533a3.008,3.008,0,0,0-3.006,3v27.059a3.008,3.008,0,0,0,3.006,3,2.97,2.97,0,0,0,1.506-.414l23.193-13.529a2.972,2.972,0,0,0,1.488-2.591,2.972,2.972,0,0,0-1.488-2.591l-23.193-13.529A2.945,2.945,0,0,0-16448.711,984.468Z"
									transform="translate(16491 -951.002)"
									fill="#fff"
									opacity="0.8"
								/>
							</svg>
							<!--              <div class="img-layer"></div>-->
							<time class="noto-semibold">{{ getPost.date }}</time>
							<div class="link" id="video-gallery">
								<a
									v-if="_.get(getPost, 'video')"
									:href="_.get(getPost, 'video')"
								></a>
							</div>
						</div>
					</div>

					<div
						class="text"
						v-html="_.get(getPost, 'content.tabs.0.content')"
					></div>

					{{ getGallery.url }}

					<div class="photo-gallery mt-34">
						<h3 class="noto-semibold ttl" v-if="getGallery.length > 0">
							{{
								_.get(
									this.$store.state.current_content,
									'primary.0.images_list_head'
								)
							}}
						</h3>
						<div class="list" id="lightgallery" v-if="getGallery.length > 0">
							<portal to="popup">
								<LightGallery
									:images="getGallery"
									:index="index"
									:disable-scroll="true"
									@close="index = null"
								/>
							</portal>
							<div
								class="item"
								v-for="(thumb, thumbIndex) in getGallery"
								:key="thumbIndex"
								@click="index = thumbIndex"
							>
								<div :data-src="thumb.url" class="light-link">
									<picture>
										<source media="(max-width: 767px)" :srcset="thumb.url" />
										<source media="(max-width: 1023px)" :srcset="thumb.url" />
										<img :src="thumb.url" class="img-absolute" alt />
									</picture>
									<div class="img-layer"></div>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="25.001"
										height="25"
										viewBox="0 0 25.001 25"
									>
										<g
											id="Group_1339"
											data-name="Group 1339"
											transform="translate(-353 -4901.998)"
										>
											<path
												id="Subtraction_27"
												data-name="Subtraction 27"
												d="M5623.5-9566c-4.883,0-7.9-.836-9.776-2.71s-2.723-4.9-2.723-9.79c0-4.8.858-7.8,2.781-9.719s4.92-2.781,9.718-2.781c4.891,0,7.91.84,9.79,2.723s2.712,4.895,2.712,9.777-.836,7.914-2.712,9.79S5628.395-9566,5623.5-9566Zm-.5-11.5v5.5h2v-5.5h5.5v-2H5625v-5.5h-2v5.5h-5.5v2Z"
												transform="translate(-5258 14493)"
												fill="#fff"
											/>
										</g>
									</svg>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="left">
					<h3 class="noto-semibold ttl">{{ $fn.tr('Other News') }}</h3>

					<!-- <h3 class="noto-semibold mt-34" v-if="getRelated.length <= 0">
            {{ $fn.tr("News not Found") }}
          </h3> -->

					<template v-for="post in getRelated">
						<router-link
							:to="$store.getters.getSingleUrl(post, 1)"
							class="article-small-box"
							:key="post.id"
							v-if="
								_.get($store.state.current_content, 'primary.0.id') != post.id
							"
						>
							<div class="img-box">
								<picture>
									<source
										media="(max-width: 767px)"
										:srcset="_.get(post, 'cover_image.0.url')"
									/>
									<source
										media="(max-width: 1023px)"
										:srcset="_.get(post, 'cover_image.0.url')"
									/>
									<img
										:src="_.get(post, 'cover_image.0.url')"
										class="img-absolute"
										alt
									/>
								</picture>
								<div class="img-layer"></div>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="100.002"
									height="99.999"
									viewBox="0 0 100.002 99.999"
									v-if="_.get(getPost, 'video')"
								>
									<path
										id="Subtraction_136"
										data-name="Subtraction 136"
										d="M-16441,1051a49.691,49.691,0,0,1-19.463-3.929,49.828,49.828,0,0,1-15.895-10.716,49.829,49.829,0,0,1-10.715-15.893A49.662,49.662,0,0,1-16491,1001a49.662,49.662,0,0,1,3.93-19.462,49.829,49.829,0,0,1,10.715-15.893,49.826,49.826,0,0,1,15.895-10.715A49.689,49.689,0,0,1-16441,951a49.689,49.689,0,0,1,19.463,3.929,49.81,49.81,0,0,1,15.893,10.715,49.775,49.775,0,0,1,10.715,15.893A49.662,49.662,0,0,1-16391,1001a49.663,49.663,0,0,1-3.93,19.462,49.777,49.777,0,0,1-10.715,15.893,49.814,49.814,0,0,1-15.893,10.716A49.691,49.691,0,0,1-16441,1051Zm-7.713-66.533a3.008,3.008,0,0,0-3.006,3v27.059a3.008,3.008,0,0,0,3.006,3,2.97,2.97,0,0,0,1.506-.414l23.193-13.529a2.972,2.972,0,0,0,1.488-2.591,2.972,2.972,0,0,0-1.488-2.591l-23.193-13.529A2.945,2.945,0,0,0-16448.711,984.468Z"
										transform="translate(16491 -951.002)"
										fill="#fff"
										opacity="0.8"
									/>
								</svg>
								<time>{{ post.updated_at }}</time>
							</div>

							<h2 class="noto-semibold ttl">
								{{ post.title }}
							</h2>
							<span class="noto-semibold article-link">{{
								$fn.tr('keep reading')
							}}</span>
						</router-link>
					</template>

					<div class="search-wrap">
						<input
							type="text"
							class="c-input"
							:placeholder="$fn.tr('Search by keyword')"
							v-model="searchByKey"
						/>
						<button>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24.998"
								height="24.998"
								viewBox="0 0 24.998 24.998"
							>
								<g
									id="Group_1309"
									data-name="Group 1309"
									transform="translate(19679.999 90.998)"
								>
									<path
										id="Subtraction_52"
										data-name="Subtraction 52"
										d="M1300.5,21229c-4.882,0-7.9-.836-9.776-2.711s-2.723-4.9-2.723-9.787c0-4.8.858-7.8,2.781-9.721s4.919-2.779,9.718-2.779c4.892,0,7.91.84,9.788,2.723s2.711,4.893,2.711,9.777-.836,7.912-2.711,9.787S1305.394,21229,1300.5,21229Zm1.662-9.5v0l2.274,2.736.054.059a1.28,1.28,0,1,0,1.747-1.863l-2.738-2.27a5.217,5.217,0,1,0-1.338,1.338Zm-2.936-.441a3.842,3.842,0,1,1,3.847-3.836A3.848,3.848,0,0,1,1299.227,21219.059Z"
										transform="translate(-20968 -21295)"
										fill="#444958"
									/>
								</g>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</intersect>
	</div>
</template>

<script>
	import AliMixin from '@/mixins/ali';
	import HeadBanner from '@/components/HeadBanner';
	import Breadcrumb from '@/components/Breadcrumb';
	import moment from 'moment';
	import Intersect from 'vue-intersect';

	export default {
		mixins: [AliMixin],

		components: {
			HeadBanner,
			Breadcrumb,
			Intersect,
		},

		data() {
			return {
				searchByKey: '',
				animate: false,
				index: null,
			};
		},

		computed: {
			getPost() {
				if (_.get(this.$store.state.current_content, 'primary') !== undefined) {
					const data = _.get(this.$store.state.current_content, 'primary.0');
					data.date = moment(data.date).format('DD MM YYYY');
					return data;
				}
			},

			getRelated() {
				let relatedContent = {};
				if (
					_.get(
						this.$store.state.current_content,
						'secondary.NewsMediaFilter.data'
					)
				) {
					relatedContent = this.$store.state.current_content.secondary
						.NewsMediaFilter.data;
				} else if (
					_.get(
						this.$store.state.current_content,
						'secondary.NewsAndMedia.data'
					)
				) {
					relatedContent = this.$store.state.current_content.secondary
						.NewsAndMedia.data;
				} else {
					return [];
				}

				for (let i in relatedContent) {
					relatedContent[i].updated_at = moment(relatedContent[i].date).format(
						'DD MM YYYY'
					);
				}

				return relatedContent;

				/*** /
      let currentId = _.get( this.$store.state, "current_content.primary.0.id" );
      let related = [];

      if (
        _.get(
          this.$store.state.current_content,
          "secondary.NewsMediaFilter.data"
        ) !== undefined
      ) {
        console.log(1111);
        related =  _.get( this.$store.state.current_content, "secondary.NewsMediaFilter.data" ).map(item => {
            item.updated_at = moment(item.updated_at).format("DD MM YYYY");
            return item;
          }).filter( item => _.lowerCase(_.get(item, "title")).indexOf( this.searchByKey.toLowerCase() ) !== -1 ).slice(0, 2);
      };

      if (!related.length) {
        console.log(_.get( this.$store.state.current_content, "secondary" ));
        return  _.get(
            this.$store.state.current_content,
            "secondary.NewsMediaFilter.data"
        )
            .map(item => {
              item.updated_at = moment(item.updated_at).format("DD MM YYYY");
              return item;
            }).slice(0, 2);
      }else {
        return related;
      }

      /***/
			},

			getGallery() {
				return this.getPost.images.slice(1);
			},
		},
		watch: {
			// "$store.state.offset": {
			//   immediate: true,
			//   handler: function () {
			//     this.popupScroll();
			//   },
			// },

			searchWord() {
				this.getSearchResults();
			},
			searchResults() {
				if (_.size(this.searchWord) == 0) {
					this.searchInnerActive = false;
					return false;
				}
				this.searchInnerActive = true;
			},
		},
		// methods: {
		//   popupScroll: function () {
		//     let galleryPopup = document.querySelector(".light-gallery__modal");
		//     galleryPopup.style.top = this.$store.state.offset + "px";
		//     galleryPopup.style.height = "100vh";
		//     console.log(this.$store.state.offset + "px");
		//     console.log(this.$store.state.offset);
		//   },
		// },
		mounted() {
			this.startLightGallery({
				// youtubePlayerParams: {
				//   autoplay: 1,
				// },
				// autoplayFirstVideo: true,
				// autoplayControls: false,
			});
		},
	};
</script>
